import { render, staticRenderFns } from "./GymVideoIntensityBadge.vue?vue&type=template&id=3c4a2fbe&scoped=true&"
import script from "./GymVideoIntensityBadge.vue?vue&type=script&lang=js&"
export * from "./GymVideoIntensityBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a2fbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4a2fbe')) {
      api.createRecord('3c4a2fbe', component.options)
    } else {
      api.reload('3c4a2fbe', component.options)
    }
    module.hot.accept("./GymVideoIntensityBadge.vue?vue&type=template&id=3c4a2fbe&scoped=true&", function () {
      api.rerender('3c4a2fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Gym/Includes/Badges/GymVideoIntensityBadge.vue"
export default component.exports